<template>
  <tr>
    <td>{{ user.index + 1 }}</td>
    <td>{{ user.item.adminid }}</td>
    <td>
      <template v-if="user.item.type == 'admin'">
        <change-password :userid="user.item.adminid"></change-password>
      </template>
    </td>
    <td>
      <template v-if="user.item.privilege">
        <UserRole :privilege="user.item.privilege" />
      </template>
      <template v-else>-</template>
    </td>
    <td>{{ user.item.groupname || '-' }}</td>
    <td>{{ user.item.subgroupname || '-' }}</td>
    <td v-if="isZwizAdmin()" style="white-space: nowrap">
      <v-btn
        v-if="!isAgent"
        fab
        small
        outline
        color="primary"
        :disabled="admins.length <= 1"
        @click="$emit('onDelete', user.item)"
        ><v-icon>delete</v-icon></v-btn
      >
      <slot name="action"></slot>
      <v-btn
        icon
        fab
        outline
        small
        color="primary"
        @click="handleToggleDialogCheckinTimeTable(true, user.item)"
      >
        <v-icon>update</v-icon>
      </v-btn>
      <v-dialog v-model="showCheckinTimeTable" width="800px" persistent>
        <template v-if="showCheckinTimeTable">
          <dialog-agent
            :dialogdata="currentAgent"
            :selected-date="selectedDate"
            @close="handleToggleDialogCheckinTimeTable(false, null)"
          ></dialog-agent>
        </template>
      </v-dialog>
    </td>
  </tr>
</template>

<script>
const ChangePassword = () => import('./ChangePassword')
import UserRole from './UserRole'
import DialogAgent from '@/components/view/ticket3/agent-management/agents/Performance/DialogAgent.vue'
import dayjs from 'dayjs'
export default {
  components: {
    ChangePassword,
    UserRole,
    DialogAgent
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    admins: {
      type: Array,
      required: true
    },
    isAgent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCheckinTimeTable: false,
      currentAgent: null,
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    handleToggleDialogCheckinTimeTable(show, agent) {
      this.showCheckinTimeTable = show
      this.currentAgent = agent
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/user/UserItem.vue